import { Component } from '@angular/core';
import { UserService } from '../../services';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css']
})

export class ProfileComponent {

    model: any = {};

    constructor(
        private userService: UserService,
        private messageService: MessageService
    ) { }

    changePassword(): void {
        if (!this.model.oldPassword || this.model.oldPassword === '') {
            this.messageService.add({
                severity: 'error',
                summary: 'Stare hasło jest puste'
            });
            return;
        }

        if (!this.model.password || this.model.password.length < 6) {
            this.messageService.add({
                severity: 'error',
                summary: 'Nowe hasło jest puste'
            });
            return;
        }

        if (this.model.password !== this.model.passwordConfirmation) {
            this.messageService.add({
                severity: 'error',
                summary: 'Nieprawidlowe powtórzenie hasła'
            });
            return;
        }

        this.userService.changePassword(this.model.oldPassword, this.model.password)
            .subscribe(
                () => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Hasło zostało zmienione'
                    })
                },
                error => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Zmiana hasła nie powiodła się'
                    })
                });
    }
}
